var render = function render(){var _vm=this,_c=_vm._self._c;return _c('module-template',{attrs:{"id":"scrolltainer","title":_vm.$t('global.menu.administration.users'),"canCreate":"","createToolTip":_vm.$t('global.header.newVowel', [
      _vm.$t('global.concepts.sysuser').toLowerCase(),
    ])},on:{"newItem":_vm.createUser}},[_c('ooliba-basic-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.busy,"no-pagination":"","height":_vm.tableHeight(85, _vm.items?.length)},on:{"row-clicked":_vm.onRowClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }